import Service from "@/helpers/service";

export default {
  get(params) {
    return Service().get("Kbli", { params });
  },
  show(code) {
    return Service().get(`Kbli/show/${code}`);
  },
};
